import nativeTechdocsPlugin from '@backstage/plugin-techdocs/alpha';

// Matches the legacy entity page's "Docs" tab: same title, ungrouped, and not on API, System, Domain or User pages.
export const nfsTechdocsPlugin = nativeTechdocsPlugin.withOverrides({
  extensions: [
    nativeTechdocsPlugin.getExtension('entity-content:techdocs').override({
      factory: (originalFactory, { config }) =>
        originalFactory({
          config: {
            ...config,
            title: config.title ?? 'Docs',
            group: config.group ?? false,
            filter: config.filter ?? {
              $not: { kind: { $in: ['api', 'system', 'domain', 'user'] } },
            },
          },
        }),
    }),
  ],
});
